import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onAIAnswerDialogClick: (
	props: commonAttributesType & {
		elementInteracted?: string;
		jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink';
		isAuxClick?: boolean;
		isContextMenu?: boolean;
	},
) => AnalyticsEventPayload = (
	props: commonAttributesType & {
		elementInteracted?: string;
		jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink';
		isAuxClick?: boolean;
		isContextMenu?: boolean;
	},
): AnalyticsEventPayload => {
	const {
		source,
		query,
		answerString,
		elementInteracted,
		jiraNlToJqlCardVariant,
		isAuxClick,
		isContextMenu,
	} = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerDialog',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			elementInteracted,
			jiraNlToJqlCardVariant,
			isAuxClick,
			isContextMenu,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
